import React from "react";
import * as AiIcons from "react-icons/ai";

export const SidebarData = [
  {
    title: "Home",
    id: "spy1",
    to: "title",
    cName: "nav-text",
    icon: <AiIcons.AiFillHome />,
    display: true,
  },
];
